import { Depository } from "../../../openapi/depository"

export type DepositoryState = {
    searchDone: boolean
    depositories?: Depository[]
    depSearchCriteria?: FormData
    error? : string    
}

export  type DepositoryAction =
    | {
      type: "Depository/SEARCHDONE",
      payload: Depository[],   
      searchCriteria: FormData 
    }
    | {
        type: "Depository/RESETSEARCH"
    }
    | {
        type: "Depository/FETCHERROR",
        payload: string
    }
  
const initialState: DepositoryState = { searchDone: false }

export    const depositoryReducer = (
        state: DepositoryState = initialState,
        action: DepositoryAction 
    ) => {
        //console.log("in Depository Reducer: state" + JSON.stringify(state)  + " tms:" + Date.now())
        switch (action.type) {
            case "Depository/SEARCHDONE":
              return { ...state,  searchDone: true, depositories: action.payload, depSearchCriteria: action.searchCriteria }
            case "Depository/RESETSEARCH" : {
                return { ...state,  searchDone: false }
            }
            case "Depository/FETCHERROR" : {
                return { ...state,  searchDone: false, error: action.payload }
            }

            default: return state
        }
    }
    